import CookieStore from './cookie';
import { COOKIE_KEY } from 'src/constants';
import { currentSecords } from './time';

export const setIdsRead = (id: number) => {
    const MAX_COUNT = 20;
    let contentReads = CookieStore.get(COOKIE_KEY.BM_CONTENT_READ) || '';
    let timeContentReads =
        CookieStore.get(COOKIE_KEY.BM_TIME_CONTENT_READ) || '';

    if (contentReads.indexOf(id) <= -1) {
        const contentIds: string[] = contentReads.split(',');
        const times: string[] = timeContentReads.split(',');

        if (contentIds.length > MAX_COUNT) {
            const _contentIds = contentIds.slice(-(MAX_COUNT - 1));
            const _times = times.slice(-(MAX_COUNT - 1));

            contentReads = '';
            timeContentReads = '';
            for (let i = 0; i < MAX_COUNT - 1; i++) {
                contentReads += ',' + _contentIds[i];
                timeContentReads += ',' + _times[i];
            }
        }

        CookieStore.set(COOKIE_KEY.BM_CONTENT_READ, contentReads + ',' + id, 0.5);
        CookieStore.set(
            COOKIE_KEY.BM_TIME_CONTENT_READ,
            timeContentReads + ',' + currentSecords(), 0.5
        );
    }
};